import { useEffect, useState, useCallback } from 'react';
import { useChat } from '../context/Context';
import useHttp from './useHttp';

export const useChatLifecycle = (setIsTokenChanged) => {
    const { widgetId, dialogId, setDialogId, messages, setMessages } = useChat();

    const [messageText, setMessageText] = useState('');
    const [isPreload, setPreload] = useState(false);

    const [dialogData, fetchDialogId, , , setDialogData] = useHttp(`widget/${widgetId}/dialog`);
    const [messagesData, messagesRequest, isLoading] = useHttp(
        `widget/${widgetId}/dialog/${dialogId?.data?.id}${isPreload ? '?preload=1' : ''}`
    );
    const [, sendMessageRequest, error] = useHttp(
        `widget/${widgetId}/dialog/${dialogId?.data?.id}?text=${encodeURIComponent(messageText)}`
    );
    const [, closeDialog] = useHttp(`widget/${widgetId}/dialog/${dialogId?.data?.id}/close`);

    useEffect(() => {
        const status = localStorage.getItem('dialogStatus');
        if (status === 'active' && !dialogId?.data?.id) {
            fetchDialogId({ method: 'POST' });
        }
    }, []);

    useEffect(() => {
        if (dialogData?.data?.id) {
            setDialogId(dialogData);
        }
    }, [dialogData]);

    useEffect(() => {
        if (messageText && dialogId?.data?.id) {
            sendMessageRequest({ method: 'POST' });
        }
    }, [messageText, dialogId?.data?.id]);

    useEffect(() => {
        if (error) {
            setIsTokenChanged(prev => !prev);
        }
    }, [error]);

    useEffect(() => {
        if (isPreload) {
            messagesRequest();
        }
    }, [isPreload]);

    useEffect(() => {
        const newMessages = [
            ...(messagesData?.data?.chat?.messages?.outcome || []),
            ...(messagesData?.data?.chat?.messages?.income || []),
        ];
        setMessages((prev) => [
            ...prev.filter((m) => !newMessages.find((n) => n.id === m.id)),
            ...newMessages,
        ]);
    }, [messagesData]);

    const preloadMessagesHandler = useCallback(() => {
        setTimeout(() => setPreload(true), 10);
    }, []);

    const sendMessage = useCallback(async (text) => {
        if (!text?.trim()) return;
        if (!dialogId?.data?.id) {
            await fetchDialogId({ method: 'POST' });
        }
        setMessageText(text);
    }, [dialogId]);

    return {
        dialogId,
        fetchDialogId,
        messages,
        setDialogData,
        isPreload,
        setPreload,
        preloadMessagesHandler,
        sendMessage,
        sendMessageRequest,
        messagesRequest,
        isLoading,
        messagesData,
        closeDialog,
    };
};
